// PaymentFailed.js - Premium Design
import React, { useEffect, useState } from 'react';
import { useBooking } from '../hooks/useBooking';
import Layout from '../components/layout/Layout';
import { PAGES } from '../utils/constants';

const PaymentFailed = () => {
  const { setCurrentPage } = useBooking();
  const [failureData, setFailureData] = useState(null);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const orderId = urlParams.get('orderId');
    const reason = urlParams.get('reason');

    setFailureData({
      orderId, reason,
      timestamp: new Date().toISOString()
    });
  }, []);

  return (
    <Layout>
      <div className="flex justify-center items-center min-h-[60vh] px-4">
        <div className="glass-panel p-10 rounded-[2.5rem] text-center max-w-md border-red-500/20 shadow-2xl animate-in fade-in zoom-in duration-500">
          <div className="w-20 h-20 bg-red-500/10 rounded-full flex items-center justify-center mx-auto mb-8 shadow-lg shadow-red-500/20 border border-red-500/20">
            <svg className="w-10 h-10 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M6 18L18 6M6 6l12 12" /></svg>
          </div>
          
          <h1 className="text-3xl font-black text-white tracking-tight mb-4 uppercase">Payment Failed</h1>
          <p className="text-gray-400 text-sm font-medium mb-8 leading-relaxed">
            The banking gateway returned an error. No funds have been captured for this booking attempt.
          </p>

          {failureData && (
            <div className="bg-red-500/5 border border-red-500/10 rounded-2xl p-5 mb-8 space-y-3">
              <div className="flex justify-between text-[10px] font-black uppercase tracking-widest">
                <span className="text-gray-500">Order Reference</span>
                <span className="text-white">{failureData.orderId || 'N/A'}</span>
              </div>
              <div className="flex justify-between text-[10px] font-black uppercase tracking-widest text-left">
                <span className="text-gray-500">Reason</span>
                <span className="text-red-400 max-w-[150px] truncate">{failureData.reason || 'Transaction Declined'}</span>
              </div>
            </div>
          )}

          <div className="space-y-4">
            <button onClick={() => setCurrentPage(PAGES.PAYMENT)} className="w-full py-4 bg-blue-600 text-white rounded-full font-black text-xs uppercase tracking-widest hover:bg-blue-700 transition-all shadow-xl shadow-blue-500/20 active:scale-95">Try Payment Again</button>
            <button onClick={() => setCurrentPage(PAGES.HOME)} className="w-full py-4 bg-white/5 border border-white/10 text-white rounded-full font-black text-xs uppercase tracking-widest hover:bg-white/10 transition-all">Start Over</button>
          </div>

          <p className="text-[10px] text-gray-600 mt-8 font-bold uppercase tracking-widest">Contat Support if you continue to see this.</p>
        </div>
      </div>
    </Layout>
  );
};

export default PaymentFailed;